import type { RootState } from '@src/store/reduxstore';
import { Department, DepartmentType } from '@types';

const PADDING_LEFT = 10;

export const departmentsSelector = (state: RootState) => state.departments;

/** Departments tree (getDepartmentsTree) – items, loading, error */
export const departmentsTreeItemsSelector = (state: RootState) =>
  state.departments.treeItems;
export const departmentsTreeLoadingSelector = (state: RootState) =>
  state.departments.treeLoading;
export const departmentsTreeErrorSelector = (state: RootState) =>
  state.departments.treeError;
export const departmentsTreeStateSelector = (state: RootState) =>
  state.departments.treeState;
export const departmentsTreeIdSelector = (state: RootState) =>
  state.departments.treeId;

export const departmentItemByIdSelector =
  (state: RootState) => (departmentId: number) =>
    state.departments.items.find(
      department => departmentId && department.departmentId === departmentId
    );

export const isDepartmentModuleActiveSelector = (state: RootState) =>
  state.departments.isDepartmentModuleActive;

export const generalDepartmentSelector = (state: RootState) =>
  state.departments.items.find(({ name }) =>
    name.includes('BotStandardServices')
  );

export const departmentsHierarchy = (state: RootState) => {
  let departments: Department[] = [];
  const parents = state.departments.items.filter(
    dep => dep.type === DepartmentType.DEPARTMENT && !dep.parentNodeId
  );

  const getChildrens = (childrens: Department[], pl: number) => {
    childrens.forEach(children => {
      const paddingLeft = pl + PADDING_LEFT;
      departments = [...departments, { ...children, paddingLeft }];

      if (children?.childrens) {
        getChildrens(children?.childrens, paddingLeft);
      }
    });
  };

  parents.forEach(parent => {
    departments = [...departments, { ...parent, paddingLeft: PADDING_LEFT }];
    if (parent?.childrens) {
      getChildrens(parent?.childrens, PADDING_LEFT);
    }
  });

  return departments;
};
